import { client } from '@/client';

let controller;

// 取消日志请求
export const abortRunningLogRequest = () => {
  if (controller) {
    controller.abort();
  }
};

// 获取集群基本状态数量 在线、离线
export function getAllClusterSize() {
  return client.get('/api/console/kop/cluster/getAllClusterSize');
}

// 集群列表
export function getClusterList(params) {
  return client.get('/api/console/kop/cluster/list', params);
}

// 新增接入集群
export function addCluster(params) {
  return client.post('/api/console/kop/cluster/addKopCluster', params);
}

// 删除集群
export function deleteCluster(clusterName) {
  return client.delete('/api/console/kop/cluster/deleteCluster', { clusterName });
}

// 更新集群
export function updateCluster(params) {
  return client.post('/api/console/kop/cluster/updateCluster', params);
}

// 查询详情
export function getClusterInfo(clusterName) {
  return client.get('/api/console/kop/cluster/getClusterInfo', { clusterName });
}

// 获取集群详情
export function getClusterDetailByName(name) {
  return client.get(`/api/console/kop/cluster/${name}`);
}

// 获取健康度状态结果
export function getInspectionRuleExecuteResults(params) {
  return client.get('/api/console/healthcheck/getInspectionRuleExecuteResults', params);
}

// 获取所有健康度配置
export function getAllInspectionRules(clusterType) {
  return client.get('/api/console/healthcheck/getAllInspectionRules', { clusterType });
}

// 获取历史事件
export function getAllClusterHistories(params) {
  return client.post(`/api/audit_log/history-query`, params);
}

// 获取图表数据
export function getChartsData(params) {
  const { clusterName, ...others } = params;
  return client.get(`/api/monitor/kop/cluster/${clusterName}`, others);
}

// 异常健康度详情
export function getUnhealthResultDetail(params) {
  return client.get('/api/console/healthcheck/getUnhealthResultDetail', params);
}

// 校验 pulsar client 地址
export function validatePulsarClient(params) {
  return client.get('/api/url/verify/pulsarClient', params);
}
// 校验 pulsar admin 地址
export function validatePulsarAdmin(params) {
  return client.get('/api/url/verify/pulsarAdmin', params);
}

// 校验 prometheusUrl 地址
export function validatePrometheus(params) {
  return client.get('/api/url/verify/prometheusUrl', params);
}

// 校验 kop 地址
export function validateKop(params) {
  return client.get('/api/url/verify/kop', params);
}

// 校验grafana地址
export function validateGrafana(params) {
  return client.get('/api/url/verify/grafana', params);
}
// 校验 bookieAdmin 地址
export function validateBookieAdmin(params) {
  return client.get('/api/url/verify/bookieAdmin', params);
}

// 校验
export function validatePulsarFunction(params) {
  return client.get('/api/url/verify/pulsarFunction', params);
}

export function getAllClusterEnvs() {
  return client.get('/api/console/env/getAllClusterEnvs');
}

// 日志列表
export function getLogFileList(params) {
  const { clusterName, host, ...others } = params;
  return client.get(`/api/log/kop/getLogFileList/${clusterName}/${host}`, others);
}

// 日志详情数据
export function getRunningLog(params) {
  controller = new AbortController();
  const { clusterName, host, ...others } = params;
  return client.get(`/api/log/kop/getRunningLog/${clusterName}/${host}`, others, {
    signal: controller.signal,
  });
}

// 更新Broker配置
export function updateBrokerService(params) {
  return client.put('/api/resource/kop/broker/config/update', params);
}

// 获取管理员列表
export function getClusterAdminList(params) {
  return client.get('/api/sys_user_service/listClusterAdminUser', params);
}
